<template>
  <div class="upload">
    <div class="container">
      <h2>
        <div v-if="title.length == 0">请拍照上传</div>
        <span v-if="title.length > 0">{{ title }}</span>
      </h2>
      <div class="imgitem">
        <img src="@/assets/img/upload01.png" alt="" />
      </div>
      <el-upload
        class="avatar-uploader"
        accept="image/*"
        action="action"
        :show-file-list="true"
        :before-upload="beforeUpload"
        :http-request="handleHttpRequest"
      >
        <div class="camera">
          <img class="icon" src="~@/assets/img/icon_camera.png" alt="" />
          <span v-if="!img" class="text">上传照片</span>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { getAliToken, ossUpload } from "@/utils/tools.js";

export default {
  components: {},
  data() {
    return {
      img: "",
      title: "",
      //上传oss
      region: "oss-cn-beijing",
      dataObj: {},
      videoOssAddress: "",
      imgOssAddress: "",
      url: "",
    };
  },
  methods: {
    // 获取选择的图片文件上传
    beforeUpload() {
      // console.log(file);
      let that = this;
      return new Promise((resolve, reject) => {
        // 获取sts 的 token
        getAliToken(that)
          .then((response) => {
            // console.log(response);
            if (response) {
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((err) => {
            // console.log(err);
            reject(err);
          });
      });
    },
    async handleHttpRequest(option) {
      // console.log("option :>> ", option);
      //   const { type } = this;
      let loading = null;
      loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      //上传OSS
      try {
        let size = (option.file.size / this.pow1024(2)).toFixed(2); //上传文件的大小  MB
        if (parseFloat(size) > 300) {
          this.$message.error("上传视频超过限制,请上传300MB以内的视频");
          return;
        }

        // 上传视频    this.dataObj为new OSS实例化的参数，上传的oss路径拼接this.videoOssAddress
        await ossUpload(option, this.dataObj, this.videoOssAddress, (res) => {
          // console.log("res :>> ", res);
          const {
            res: { statusCode, requestUrls },
          } = res; //返回状态和 url
          if (statusCode == 200) {
            let url = requestUrls[0].split("?")[0];
            this.$message({
              dangerouslyUseHTMLString: true,
              message: "<strong style='font-size:24px'>上传成功</strong>",
              type: 'success'
            });
            this.title =
              "您的保单已上传,2个工作日内会有专属保单顾问与您取得联系";
            loading.close();
            this.url = url;
          } else {
            loading.close();
          }
        });
      } catch (error) {
        // console.log("error :>> ", error);
        loading.close();
      }
    },
    pow1024(num) {
      return Math.pow(1024, num);
    },
  },
  mounted() {
    // this.getAliToken();
  },
};
</script>

<style lang="less" scoped>
.upload {
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;

    h2 {
      margin: 2.6rem 0;
      margin-top: 4.6rem;
      font-size: 2.6rem;
      span {
        color: #646ad8;
      }
    }
    .imgitem {
      margin: 6rem 0;
      width: 30rem;
      img {
        width: 100%;
      }
    }
  }
}
.hide_file {
  display: none;
}
.camera {
  position: relative;
  z-index: 2;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 138px;
  height: 138px;
  border: 0.8rem solid #646ad8;
  background: #ffffff;
  border-radius: 50%;
  text-align: center;
  .bigImg {
    width: 138px;
    height: 138px;
  }
  .icon {
    width: 40px;
    margin-top: 40px;
  }
  .text {
    display: block;
    line-height: 22px;
    font-size: 15px;
    color: #999;
    margin-top: 8px;
  }
}
</style>
